<template>
    <button class="btn" :class="{active: isActive}" @click="onclick">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 12" width="15" height="15"><path fill="currentColor" d="M3.5 5.58c.24-.28.65-.3.92-.07L7.5 8.14l3.08-2.63a.65.65 0 1 1 .84.98L7.5 9.86 3.58 6.49a.65.65 0 0 1-.07-.91z"></path></svg>
    </button>

</template>
<script>

import Icons from '../stuff/icons.json'

export default {
    name: 'ToggleButton',
    props: ['index', 'name', 'active'],
    mounted() {
    },
    data() {
      return {
        isActive: this.$props.active,
      };
    },
    computed: {
        base64() {
            return this.icon || Icons[this.file_name]
        },
        file_name() {
            let id = this.$props.id
            if (this.$props.id === 'display') {
                id = this.$props.display ? 'display_on' : 'display_off'
            }
            return id + '.png'
        },
        uuid() {
            let tv = this.$props.tv_id
            let gr = this.$props.grid_id
            let ov = this.$props.ov_id
            return `${tv}-btn-g${gr}-${ov}`
        },
        data_type() {
            return this.$props.grid_id === 0 ?
                "onchart" : "offchart"
        },
        data_index() {
            return this.$props.index
        }
    },
    methods: {
        onclick(event) {
            this.isActive = !this.isActive
            let button = event.target;
            button.classList.toggle('active');
            this.$emit('toggle-button-click', {
                button: this.$props.id,
                type: this.data_type,
                active: this.isActive,
                dataIndex: this.data_index,
                grid: this.$props.grid_id,
                overlay: this.$props.ov_id,
            })
        }
    }
}
</script>
<style>

.btn-grp {
    padding: 2px;
    margin-right: 0px;
    border: 1px solid #d1d4dc;
    border-radius: 20% !important;
    height: 16px;
    background-color: rgba(255, 255, 255, 0.8);
    pointer-events: all;
    cursor: pointer;
    z-index: 999;
    transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
}

.btn {
    padding: 2px;
    margin-right: 0px;
    border: 1px solid #d1d4dc;
    border-radius: 20%;
    height: 16px;
    background-color: rgba(255, 255, 255, 0.8);
    pointer-events: all;
    cursor: pointer;
    z-index: 999;
    transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
}

.active {
    transition: width 0.2s, height 0.2s, transform 0.2s;
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
}
.t-vue-lbtn {
    z-index: 100;
    pointer-events: all;
    cursor: pointer;
}
.t-vue-lbtn::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0;
  transition: all 0.3s;
  border-top-width: 1px;
  border-bottom-width: 1px;
  border-top-style: solid;
  border-bottom-style: solid;
  border-top-color: rgba(255,255,255,0.5);
  border-bottom-color: rgba(255,255,255,0.5);
  transform: scale(0.1, 1);
}
.t-vue-lbtn::after {

}
.t-vue-lbtn:hover::before {
  opacity: 1;
  transform: scale(1, 1);
}
.t-vue-lbtn:hover::before {
  opacity: 0;
  transform: scale(0.1, 1);
}
</style>
